export const getPageName = (pathname: string) => {
  const pathList = pathname.split('/').filter(Boolean);
  const isBlogRouting = pathList[0] === 'blog' && pathList.length > 1;
  return isBlogRouting ? 'blogRouting' : pathList[0];
};
